var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDots2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 165,
    height: 161,
    viewBox: "0 0 165 161",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M160.5 160.1C162.599 160.1 164.3 158.399 164.3 156.3C164.3 154.201 162.599 152.5 160.5 152.5C158.401 152.5 156.7 154.201 156.7 156.3C156.7 158.399 158.401 160.1 160.5 160.1Z",
    fill: "#7965EF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M144.8 160.1C146.899 160.1 148.6 158.399 148.6 156.3C148.6 154.201 146.899 152.5 144.8 152.5C142.701 152.5 141 154.201 141 156.3C141 158.399 142.701 160.1 144.8 160.1Z",
    fill: "#7965EF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M129.2 160.1C131.299 160.1 133 158.399 133 156.3C133 154.201 131.299 152.5 129.2 152.5C127.101 152.5 125.4 154.201 125.4 156.3C125.4 158.399 127.101 160.1 129.2 160.1Z",
    fill: "#7965EF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M113.5 160.1C115.599 160.1 117.3 158.399 117.3 156.3C117.3 154.201 115.599 152.5 113.5 152.5C111.401 152.5 109.7 154.201 109.7 156.3C109.7 158.399 111.401 160.1 113.5 160.1Z",
    fill: "#7965EF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M97.8 160.1C99.8987 160.1 101.6 158.399 101.6 156.3C101.6 154.201 99.8987 152.5 97.8 152.5C95.7013 152.5 94 154.201 94 156.3C94 158.399 95.7013 160.1 97.8 160.1Z",
    fill: "#7965EF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M82.1 160.1C84.1987 160.1 85.9001 158.399 85.9001 156.3C85.9001 154.201 84.1987 152.5 82.1 152.5C80.0014 152.5 78.3 154.201 78.3 156.3C78.3 158.399 80.0014 160.1 82.1 160.1Z",
    fill: "#7965EF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M66.4999 160.1C68.5986 160.1 70.2999 158.399 70.2999 156.3C70.2999 154.201 68.5986 152.5 66.4999 152.5C64.4013 152.5 62.7 154.201 62.7 156.3C62.7 158.399 64.4013 160.1 66.4999 160.1Z",
    fill: "#7965EF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M50.8 160.1C52.8987 160.1 54.6 158.399 54.6 156.3C54.6 154.201 52.8987 152.5 50.8 152.5C48.7013 152.5 47 154.201 47 156.3C47 158.399 48.7013 160.1 50.8 160.1Z",
    fill: "#7965EF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M35.1 160.1C37.1987 160.1 38.9001 158.399 38.9001 156.3C38.9001 154.201 37.1987 152.5 35.1 152.5C33.0014 152.5 31.3 154.201 31.3 156.3C31.3 158.399 33.0014 160.1 35.1 160.1Z",
    fill: "#7965EF"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M19.4 160.1C21.4987 160.1 23.2 158.399 23.2 156.3C23.2 154.201 21.4987 152.5 19.4 152.5C17.3013 152.5 15.6 154.201 15.6 156.3C15.6 158.399 17.3013 160.1 19.4 160.1Z",
    fill: "#7965EF"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M3.79999 160.1C5.89867 160.1 7.59998 158.399 7.59998 156.3C7.59998 154.201 5.89867 152.5 3.79999 152.5C1.70131 152.5 0 154.201 0 156.3C0 158.399 1.70131 160.1 3.79999 160.1Z",
    fill: "#7965EF"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M160.5 143.2C162.599 143.2 164.3 141.499 164.3 139.4C164.3 137.301 162.599 135.6 160.5 135.6C158.401 135.6 156.7 137.301 156.7 139.4C156.7 141.499 158.401 143.2 160.5 143.2Z",
    fill: "#7965EF"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M144.8 143.2C146.899 143.2 148.6 141.499 148.6 139.4C148.6 137.301 146.899 135.6 144.8 135.6C142.701 135.6 141 137.301 141 139.4C141 141.499 142.701 143.2 144.8 143.2Z",
    fill: "#7965EF"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M129.2 143.2C131.299 143.2 133 141.499 133 139.4C133 137.301 131.299 135.6 129.2 135.6C127.101 135.6 125.4 137.301 125.4 139.4C125.4 141.499 127.101 143.2 129.2 143.2Z",
    fill: "#7965EF"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M113.5 143.2C115.599 143.2 117.3 141.499 117.3 139.4C117.3 137.301 115.599 135.6 113.5 135.6C111.401 135.6 109.7 137.301 109.7 139.4C109.7 141.499 111.401 143.2 113.5 143.2Z",
    fill: "#7965EF"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M97.8 143.2C99.8987 143.2 101.6 141.499 101.6 139.4C101.6 137.301 99.8987 135.6 97.8 135.6C95.7013 135.6 94 137.301 94 139.4C94 141.499 95.7013 143.2 97.8 143.2Z",
    fill: "#7965EF"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M82.1 143.2C84.1987 143.2 85.9001 141.499 85.9001 139.4C85.9001 137.301 84.1987 135.6 82.1 135.6C80.0014 135.6 78.3 137.301 78.3 139.4C78.3 141.499 80.0014 143.2 82.1 143.2Z",
    fill: "#7965EF"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M66.4999 143.2C68.5986 143.2 70.2999 141.499 70.2999 139.4C70.2999 137.301 68.5986 135.6 66.4999 135.6C64.4013 135.6 62.7 137.301 62.7 139.4C62.7 141.499 64.4013 143.2 66.4999 143.2Z",
    fill: "#7965EF"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M50.8 143.2C52.8987 143.2 54.6 141.499 54.6 139.4C54.6 137.301 52.8987 135.6 50.8 135.6C48.7013 135.6 47 137.301 47 139.4C47 141.499 48.7013 143.2 50.8 143.2Z",
    fill: "#7965EF"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M35.1 143.2C37.1987 143.2 38.9001 141.499 38.9001 139.4C38.9001 137.301 37.1987 135.6 35.1 135.6C33.0014 135.6 31.3 137.301 31.3 139.4C31.3 141.499 33.0014 143.2 35.1 143.2Z",
    fill: "#7965EF"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M19.4 143.2C21.4987 143.2 23.2 141.499 23.2 139.4C23.2 137.301 21.4987 135.6 19.4 135.6C17.3013 135.6 15.6 137.301 15.6 139.4C15.6 141.499 17.3013 143.2 19.4 143.2Z",
    fill: "#7965EF"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M3.79999 143.2C5.89867 143.2 7.59998 141.499 7.59998 139.4C7.59998 137.301 5.89867 135.6 3.79999 135.6C1.70131 135.6 0 137.301 0 139.4C0 141.499 1.70131 143.2 3.79999 143.2Z",
    fill: "#7965EF"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M160.5 126.2C162.599 126.2 164.3 124.499 164.3 122.4C164.3 120.301 162.599 118.6 160.5 118.6C158.401 118.6 156.7 120.301 156.7 122.4C156.7 124.499 158.401 126.2 160.5 126.2Z",
    fill: "#7965EF"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M144.8 126.2C146.899 126.2 148.6 124.499 148.6 122.4C148.6 120.301 146.899 118.6 144.8 118.6C142.701 118.6 141 120.301 141 122.4C141 124.499 142.701 126.2 144.8 126.2Z",
    fill: "#7965EF"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M129.2 126.2C131.299 126.2 133 124.499 133 122.4C133 120.301 131.299 118.6 129.2 118.6C127.101 118.6 125.4 120.301 125.4 122.4C125.4 124.499 127.101 126.2 129.2 126.2Z",
    fill: "#7965EF"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M113.5 126.2C115.599 126.2 117.3 124.499 117.3 122.4C117.3 120.301 115.599 118.6 113.5 118.6C111.401 118.6 109.7 120.301 109.7 122.4C109.7 124.499 111.401 126.2 113.5 126.2Z",
    fill: "#7965EF"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M97.8 126.2C99.8987 126.2 101.6 124.499 101.6 122.4C101.6 120.301 99.8987 118.6 97.8 118.6C95.7013 118.6 94 120.301 94 122.4C94 124.499 95.7013 126.2 97.8 126.2Z",
    fill: "#7965EF"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M82.1 126.2C84.1987 126.2 85.9001 124.499 85.9001 122.4C85.9001 120.301 84.1987 118.6 82.1 118.6C80.0014 118.6 78.3 120.301 78.3 122.4C78.3 124.499 80.0014 126.2 82.1 126.2Z",
    fill: "#7965EF"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M66.4999 126.2C68.5986 126.2 70.2999 124.499 70.2999 122.4C70.2999 120.301 68.5986 118.6 66.4999 118.6C64.4013 118.6 62.7 120.301 62.7 122.4C62.7 124.499 64.4013 126.2 66.4999 126.2Z",
    fill: "#7965EF"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M50.8 126.2C52.8987 126.2 54.6 124.499 54.6 122.4C54.6 120.301 52.8987 118.6 50.8 118.6C48.7013 118.6 47 120.301 47 122.4C47 124.499 48.7013 126.2 50.8 126.2Z",
    fill: "#7965EF"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M35.1 126.2C37.1987 126.2 38.9001 124.499 38.9001 122.4C38.9001 120.301 37.1987 118.6 35.1 118.6C33.0014 118.6 31.3 120.301 31.3 122.4C31.3 124.499 33.0014 126.2 35.1 126.2Z",
    fill: "#7965EF"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M19.4 126.2C21.4987 126.2 23.2 124.499 23.2 122.4C23.2 120.301 21.4987 118.6 19.4 118.6C17.3013 118.6 15.6 120.301 15.6 122.4C15.6 124.499 17.3013 126.2 19.4 126.2Z",
    fill: "#7965EF"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M3.79999 126.2C5.89867 126.2 7.59998 124.499 7.59998 122.4C7.59998 120.301 5.89867 118.6 3.79999 118.6C1.70131 118.6 0 120.301 0 122.4C0 124.499 1.70131 126.2 3.79999 126.2Z",
    fill: "#7965EF"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M160.5 109.3C162.599 109.3 164.3 107.599 164.3 105.5C164.3 103.401 162.599 101.7 160.5 101.7C158.401 101.7 156.7 103.401 156.7 105.5C156.7 107.599 158.401 109.3 160.5 109.3Z",
    fill: "#7965EF"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M144.8 109.3C146.899 109.3 148.6 107.599 148.6 105.5C148.6 103.401 146.899 101.7 144.8 101.7C142.701 101.7 141 103.401 141 105.5C141 107.599 142.701 109.3 144.8 109.3Z",
    fill: "#7965EF"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M129.2 109.3C131.299 109.3 133 107.599 133 105.5C133 103.401 131.299 101.7 129.2 101.7C127.101 101.7 125.4 103.401 125.4 105.5C125.4 107.599 127.101 109.3 129.2 109.3Z",
    fill: "#7965EF"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M113.5 109.3C115.599 109.3 117.3 107.599 117.3 105.5C117.3 103.401 115.599 101.7 113.5 101.7C111.401 101.7 109.7 103.401 109.7 105.5C109.7 107.599 111.401 109.3 113.5 109.3Z",
    fill: "#7965EF"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M97.8 109.3C99.8987 109.3 101.6 107.599 101.6 105.5C101.6 103.401 99.8987 101.7 97.8 101.7C95.7013 101.7 94 103.401 94 105.5C94 107.599 95.7013 109.3 97.8 109.3Z",
    fill: "#7965EF"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M82.1 109.3C84.1987 109.3 85.9001 107.599 85.9001 105.5C85.9001 103.401 84.1987 101.7 82.1 101.7C80.0014 101.7 78.3 103.401 78.3 105.5C78.3 107.599 80.0014 109.3 82.1 109.3Z",
    fill: "#7965EF"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M66.4999 109.3C68.5986 109.3 70.2999 107.599 70.2999 105.5C70.2999 103.401 68.5986 101.7 66.4999 101.7C64.4013 101.7 62.7 103.401 62.7 105.5C62.7 107.599 64.4013 109.3 66.4999 109.3Z",
    fill: "#7965EF"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M50.8 109.3C52.8987 109.3 54.6 107.599 54.6 105.5C54.6 103.401 52.8987 101.7 50.8 101.7C48.7013 101.7 47 103.401 47 105.5C47 107.599 48.7013 109.3 50.8 109.3Z",
    fill: "#7965EF"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M35.1 109.3C37.1987 109.3 38.9001 107.599 38.9001 105.5C38.9001 103.401 37.1987 101.7 35.1 101.7C33.0014 101.7 31.3 103.401 31.3 105.5C31.3 107.599 33.0014 109.3 35.1 109.3Z",
    fill: "#7965EF"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M19.4 109.3C21.4987 109.3 23.2 107.599 23.2 105.5C23.2 103.401 21.4987 101.7 19.4 101.7C17.3013 101.7 15.6 103.401 15.6 105.5C15.6 107.599 17.3013 109.3 19.4 109.3Z",
    fill: "#7965EF"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M3.79999 109.3C5.89867 109.3 7.59998 107.599 7.59998 105.5C7.59998 103.401 5.89867 101.7 3.79999 101.7C1.70131 101.7 0 103.401 0 105.5C0 107.599 1.70131 109.3 3.79999 109.3Z",
    fill: "#7965EF"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M160.5 92.4001C162.599 92.4001 164.3 90.6987 164.3 88.6001C164.3 86.5014 162.599 84.8 160.5 84.8C158.401 84.8 156.7 86.5014 156.7 88.6001C156.7 90.6987 158.401 92.4001 160.5 92.4001Z",
    fill: "#7965EF"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M144.8 92.4001C146.899 92.4001 148.6 90.6987 148.6 88.6001C148.6 86.5014 146.899 84.8 144.8 84.8C142.701 84.8 141 86.5014 141 88.6001C141 90.6987 142.701 92.4001 144.8 92.4001Z",
    fill: "#7965EF"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M129.2 92.4001C131.299 92.4001 133 90.6987 133 88.6001C133 86.5014 131.299 84.8 129.2 84.8C127.101 84.8 125.4 86.5014 125.4 88.6001C125.4 90.6987 127.101 92.4001 129.2 92.4001Z",
    fill: "#7965EF"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M113.5 92.4001C115.599 92.4001 117.3 90.6987 117.3 88.6001C117.3 86.5014 115.599 84.8 113.5 84.8C111.401 84.8 109.7 86.5014 109.7 88.6001C109.7 90.6987 111.401 92.4001 113.5 92.4001Z",
    fill: "#7965EF"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M97.8 92.4001C99.8987 92.4001 101.6 90.6987 101.6 88.6001C101.6 86.5014 99.8987 84.8 97.8 84.8C95.7013 84.8 94 86.5014 94 88.6001C94 90.6987 95.7013 92.4001 97.8 92.4001Z",
    fill: "#7965EF"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M82.1 92.4001C84.1987 92.4001 85.9001 90.6987 85.9001 88.6001C85.9001 86.5014 84.1987 84.8 82.1 84.8C80.0014 84.8 78.3 86.5014 78.3 88.6001C78.3 90.6987 80.0014 92.4001 82.1 92.4001Z",
    fill: "#7965EF"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M66.4999 92.4001C68.5986 92.4001 70.2999 90.6987 70.2999 88.6001C70.2999 86.5014 68.5986 84.8 66.4999 84.8C64.4013 84.8 62.7 86.5014 62.7 88.6001C62.7 90.6987 64.4013 92.4001 66.4999 92.4001Z",
    fill: "#7965EF"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M50.8 92.4001C52.8987 92.4001 54.6 90.6987 54.6 88.6001C54.6 86.5014 52.8987 84.8 50.8 84.8C48.7013 84.8 47 86.5014 47 88.6001C47 90.6987 48.7013 92.4001 50.8 92.4001Z",
    fill: "#7965EF"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M35.1 92.4001C37.1987 92.4001 38.9001 90.6987 38.9001 88.6001C38.9001 86.5014 37.1987 84.8 35.1 84.8C33.0014 84.8 31.3 86.5014 31.3 88.6001C31.3 90.6987 33.0014 92.4001 35.1 92.4001Z",
    fill: "#7965EF"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M19.4 92.4001C21.4987 92.4001 23.2 90.6987 23.2 88.6001C23.2 86.5014 21.4987 84.8 19.4 84.8C17.3013 84.8 15.6 86.5014 15.6 88.6001C15.6 90.6987 17.3013 92.4001 19.4 92.4001Z",
    fill: "#7965EF"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M3.79999 92.4001C5.89867 92.4001 7.59998 90.6987 7.59998 88.6001C7.59998 86.5014 5.89867 84.8 3.79999 84.8C1.70131 84.8 0 86.5014 0 88.6001C0 90.6987 1.70131 92.4001 3.79999 92.4001Z",
    fill: "#7965EF"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M160.5 75.5C162.599 75.5 164.3 73.7987 164.3 71.7C164.3 69.6014 162.599 67.9 160.5 67.9C158.401 67.9 156.7 69.6014 156.7 71.7C156.7 73.7987 158.401 75.5 160.5 75.5Z",
    fill: "#7965EF"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M144.8 75.5C146.899 75.5 148.6 73.7987 148.6 71.7C148.6 69.6014 146.899 67.9 144.8 67.9C142.701 67.9 141 69.6014 141 71.7C141 73.7987 142.701 75.5 144.8 75.5Z",
    fill: "#7965EF"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M129.2 75.5C131.299 75.5 133 73.7987 133 71.7C133 69.6014 131.299 67.9 129.2 67.9C127.101 67.9 125.4 69.6014 125.4 71.7C125.4 73.7987 127.101 75.5 129.2 75.5Z",
    fill: "#7965EF"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M113.5 75.5C115.599 75.5 117.3 73.7987 117.3 71.7C117.3 69.6014 115.599 67.9 113.5 67.9C111.401 67.9 109.7 69.6014 109.7 71.7C109.7 73.7987 111.401 75.5 113.5 75.5Z",
    fill: "#7965EF"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M97.8 75.5C99.8987 75.5 101.6 73.7987 101.6 71.7C101.6 69.6014 99.8987 67.9 97.8 67.9C95.7013 67.9 94 69.6014 94 71.7C94 73.7987 95.7013 75.5 97.8 75.5Z",
    fill: "#7965EF"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M82.1 75.5C84.1987 75.5 85.9001 73.7987 85.9001 71.7C85.9001 69.6014 84.1987 67.9 82.1 67.9C80.0014 67.9 78.3 69.6014 78.3 71.7C78.3 73.7987 80.0014 75.5 82.1 75.5Z",
    fill: "#7965EF"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M66.4999 75.5C68.5986 75.5 70.2999 73.7987 70.2999 71.7C70.2999 69.6014 68.5986 67.9 66.4999 67.9C64.4013 67.9 62.7 69.6014 62.7 71.7C62.7 73.7987 64.4013 75.5 66.4999 75.5Z",
    fill: "#7965EF"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M50.8 75.5C52.8987 75.5 54.6 73.7987 54.6 71.7C54.6 69.6014 52.8987 67.9 50.8 67.9C48.7013 67.9 47 69.6014 47 71.7C47 73.7987 48.7013 75.5 50.8 75.5Z",
    fill: "#7965EF"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M35.1 75.5C37.1987 75.5 38.9001 73.7987 38.9001 71.7C38.9001 69.6014 37.1987 67.9 35.1 67.9C33.0014 67.9 31.3 69.6014 31.3 71.7C31.3 73.7987 33.0014 75.5 35.1 75.5Z",
    fill: "#7965EF"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M19.4 75.5C21.4987 75.5 23.2 73.7987 23.2 71.7C23.2 69.6014 21.4987 67.9 19.4 67.9C17.3013 67.9 15.6 69.6014 15.6 71.7C15.6 73.7987 17.3013 75.5 19.4 75.5Z",
    fill: "#7965EF"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M3.79999 75.5C5.89867 75.5 7.59998 73.7987 7.59998 71.7C7.59998 69.6014 5.89867 67.9 3.79999 67.9C1.70131 67.9 0 69.6014 0 71.7C0 73.7987 1.70131 75.5 3.79999 75.5Z",
    fill: "#7965EF"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M160.5 58.5C162.599 58.5 164.3 56.7987 164.3 54.7C164.3 52.6014 162.599 50.9 160.5 50.9C158.401 50.9 156.7 52.6014 156.7 54.7C156.7 56.7987 158.401 58.5 160.5 58.5Z",
    fill: "#7965EF"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M144.8 58.5C146.899 58.5 148.6 56.7987 148.6 54.7C148.6 52.6014 146.899 50.9 144.8 50.9C142.701 50.9 141 52.6014 141 54.7C141 56.7987 142.701 58.5 144.8 58.5Z",
    fill: "#7965EF"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M129.2 58.5C131.299 58.5 133 56.7987 133 54.7C133 52.6014 131.299 50.9 129.2 50.9C127.101 50.9 125.4 52.6014 125.4 54.7C125.4 56.7987 127.101 58.5 129.2 58.5Z",
    fill: "#7965EF"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M113.5 58.5C115.599 58.5 117.3 56.7987 117.3 54.7C117.3 52.6014 115.599 50.9 113.5 50.9C111.401 50.9 109.7 52.6014 109.7 54.7C109.7 56.7987 111.401 58.5 113.5 58.5Z",
    fill: "#7965EF"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M97.8 58.5C99.8987 58.5 101.6 56.7987 101.6 54.7C101.6 52.6014 99.8987 50.9 97.8 50.9C95.7013 50.9 94 52.6014 94 54.7C94 56.7987 95.7013 58.5 97.8 58.5Z",
    fill: "#7965EF"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M82.1 58.5C84.1987 58.5 85.9001 56.7987 85.9001 54.7C85.9001 52.6014 84.1987 50.9 82.1 50.9C80.0014 50.9 78.3 52.6014 78.3 54.7C78.3 56.7987 80.0014 58.5 82.1 58.5Z",
    fill: "#7965EF"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M66.4999 58.5C68.5986 58.5 70.2999 56.7987 70.2999 54.7C70.2999 52.6014 68.5986 50.9 66.4999 50.9C64.4013 50.9 62.7 52.6014 62.7 54.7C62.7 56.7987 64.4013 58.5 66.4999 58.5Z",
    fill: "#7965EF"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M50.8 58.5C52.8987 58.5 54.6 56.7987 54.6 54.7C54.6 52.6014 52.8987 50.9 50.8 50.9C48.7013 50.9 47 52.6014 47 54.7C47 56.7987 48.7013 58.5 50.8 58.5Z",
    fill: "#7965EF"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M35.1 58.5C37.1987 58.5 38.9001 56.7987 38.9001 54.7C38.9001 52.6014 37.1987 50.9 35.1 50.9C33.0014 50.9 31.3 52.6014 31.3 54.7C31.3 56.7987 33.0014 58.5 35.1 58.5Z",
    fill: "#7965EF"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M19.4 58.5C21.4987 58.5 23.2 56.7987 23.2 54.7C23.2 52.6014 21.4987 50.9 19.4 50.9C17.3013 50.9 15.6 52.6014 15.6 54.7C15.6 56.7987 17.3013 58.5 19.4 58.5Z",
    fill: "#7965EF"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M3.79999 58.5C5.89867 58.5 7.59998 56.7987 7.59998 54.7C7.59998 52.6014 5.89867 50.9 3.79999 50.9C1.70131 50.9 0 52.6014 0 54.7C0 56.7987 1.70131 58.5 3.79999 58.5Z",
    fill: "#7965EF"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M160.5 41.6C162.599 41.6 164.3 39.8987 164.3 37.8C164.3 35.7013 162.599 34 160.5 34C158.401 34 156.7 35.7013 156.7 37.8C156.7 39.8987 158.401 41.6 160.5 41.6Z",
    fill: "#7965EF"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M144.8 41.6C146.899 41.6 148.6 39.8987 148.6 37.8C148.6 35.7013 146.899 34 144.8 34C142.701 34 141 35.7013 141 37.8C141 39.8987 142.701 41.6 144.8 41.6Z",
    fill: "#7965EF"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M129.2 41.6C131.299 41.6 133 39.8987 133 37.8C133 35.7013 131.299 34 129.2 34C127.101 34 125.4 35.7013 125.4 37.8C125.4 39.8987 127.101 41.6 129.2 41.6Z",
    fill: "#7965EF"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M113.5 41.6C115.599 41.6 117.3 39.8987 117.3 37.8C117.3 35.7013 115.599 34 113.5 34C111.401 34 109.7 35.7013 109.7 37.8C109.7 39.8987 111.401 41.6 113.5 41.6Z",
    fill: "#7965EF"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M97.8 41.6C99.8987 41.6 101.6 39.8987 101.6 37.8C101.6 35.7013 99.8987 34 97.8 34C95.7013 34 94 35.7013 94 37.8C94 39.8987 95.7013 41.6 97.8 41.6Z",
    fill: "#7965EF"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M82.1 41.6C84.1987 41.6 85.9001 39.8987 85.9001 37.8C85.9001 35.7013 84.1987 34 82.1 34C80.0014 34 78.3 35.7013 78.3 37.8C78.3 39.8987 80.0014 41.6 82.1 41.6Z",
    fill: "#7965EF"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M66.4999 41.6C68.5986 41.6 70.2999 39.8987 70.2999 37.8C70.2999 35.7013 68.5986 34 66.4999 34C64.4013 34 62.7 35.7013 62.7 37.8C62.7 39.8987 64.4013 41.6 66.4999 41.6Z",
    fill: "#7965EF"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M50.8 41.6C52.8987 41.6 54.6 39.8987 54.6 37.8C54.6 35.7013 52.8987 34 50.8 34C48.7013 34 47 35.7013 47 37.8C47 39.8987 48.7013 41.6 50.8 41.6Z",
    fill: "#7965EF"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M35.1 41.6C37.1987 41.6 38.9001 39.8987 38.9001 37.8C38.9001 35.7013 37.1987 34 35.1 34C33.0014 34 31.3 35.7013 31.3 37.8C31.3 39.8987 33.0014 41.6 35.1 41.6Z",
    fill: "#7965EF"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M19.4 41.6C21.4987 41.6 23.2 39.8987 23.2 37.8C23.2 35.7013 21.4987 34 19.4 34C17.3013 34 15.6 35.7013 15.6 37.8C15.6 39.8987 17.3013 41.6 19.4 41.6Z",
    fill: "#7965EF"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M3.79999 41.6C5.89867 41.6 7.59998 39.8987 7.59998 37.8C7.59998 35.7013 5.89867 34 3.79999 34C1.70131 34 0 35.7013 0 37.8C0 39.8987 1.70131 41.6 3.79999 41.6Z",
    fill: "#7965EF"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M160.5 24.7C162.599 24.7 164.3 22.9986 164.3 20.9C164.3 18.8013 162.599 17.1 160.5 17.1C158.401 17.1 156.7 18.8013 156.7 20.9C156.7 22.9986 158.401 24.7 160.5 24.7Z",
    fill: "#7965EF"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M144.8 24.7C146.899 24.7 148.6 22.9986 148.6 20.9C148.6 18.8013 146.899 17.1 144.8 17.1C142.701 17.1 141 18.8013 141 20.9C141 22.9986 142.701 24.7 144.8 24.7Z",
    fill: "#7965EF"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M129.2 24.7C131.299 24.7 133 22.9986 133 20.9C133 18.8013 131.299 17.1 129.2 17.1C127.101 17.1 125.4 18.8013 125.4 20.9C125.4 22.9986 127.101 24.7 129.2 24.7Z",
    fill: "#7965EF"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M113.5 24.7C115.599 24.7 117.3 22.9986 117.3 20.9C117.3 18.8013 115.599 17.1 113.5 17.1C111.401 17.1 109.7 18.8013 109.7 20.9C109.7 22.9986 111.401 24.7 113.5 24.7Z",
    fill: "#7965EF"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M97.8 24.7C99.8987 24.7 101.6 22.9986 101.6 20.9C101.6 18.8013 99.8987 17.1 97.8 17.1C95.7013 17.1 94 18.8013 94 20.9C94 22.9986 95.7013 24.7 97.8 24.7Z",
    fill: "#7965EF"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M82.1 24.7C84.1987 24.7 85.9001 22.9986 85.9001 20.9C85.9001 18.8013 84.1987 17.1 82.1 17.1C80.0014 17.1 78.3 18.8013 78.3 20.9C78.3 22.9986 80.0014 24.7 82.1 24.7Z",
    fill: "#7965EF"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M66.4999 24.7C68.5986 24.7 70.2999 22.9986 70.2999 20.9C70.2999 18.8013 68.5986 17.1 66.4999 17.1C64.4013 17.1 62.7 18.8013 62.7 20.9C62.7 22.9986 64.4013 24.7 66.4999 24.7Z",
    fill: "#7965EF"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M50.8 24.7C52.8987 24.7 54.6 22.9986 54.6 20.9C54.6 18.8013 52.8987 17.1 50.8 17.1C48.7013 17.1 47 18.8013 47 20.9C47 22.9986 48.7013 24.7 50.8 24.7Z",
    fill: "#7965EF"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M35.1 24.7C37.1987 24.7 38.9001 22.9986 38.9001 20.9C38.9001 18.8013 37.1987 17.1 35.1 17.1C33.0014 17.1 31.3 18.8013 31.3 20.9C31.3 22.9986 33.0014 24.7 35.1 24.7Z",
    fill: "#7965EF"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M19.4 24.7C21.4987 24.7 23.2 22.9986 23.2 20.9C23.2 18.8013 21.4987 17.1 19.4 17.1C17.3013 17.1 15.6 18.8013 15.6 20.9C15.6 22.9986 17.3013 24.7 19.4 24.7Z",
    fill: "#7965EF"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M3.79999 24.7C5.89867 24.7 7.59998 22.9986 7.59998 20.9C7.59998 18.8013 5.89867 17.1 3.79999 17.1C1.70131 17.1 0 18.8013 0 20.9C0 22.9986 1.70131 24.7 3.79999 24.7Z",
    fill: "#7965EF"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M160.5 7.69997C162.599 7.69997 164.3 5.99865 164.3 3.89996C164.3 1.80128 162.599 0.0999756 160.5 0.0999756C158.401 0.0999756 156.7 1.80128 156.7 3.89996C156.7 5.99865 158.401 7.69997 160.5 7.69997Z",
    fill: "#7965EF"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M144.8 7.69997C146.899 7.69997 148.6 5.99865 148.6 3.89996C148.6 1.80128 146.899 0.0999756 144.8 0.0999756C142.701 0.0999756 141 1.80128 141 3.89996C141 5.99865 142.701 7.69997 144.8 7.69997Z",
    fill: "#7965EF"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M129.2 7.69997C131.299 7.69997 133 5.99865 133 3.89996C133 1.80128 131.299 0.0999756 129.2 0.0999756C127.101 0.0999756 125.4 1.80128 125.4 3.89996C125.4 5.99865 127.101 7.69997 129.2 7.69997Z",
    fill: "#7965EF"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M113.5 7.69997C115.599 7.69997 117.3 5.99865 117.3 3.89996C117.3 1.80128 115.599 0.0999756 113.5 0.0999756C111.401 0.0999756 109.7 1.80128 109.7 3.89996C109.7 5.99865 111.401 7.69997 113.5 7.69997Z",
    fill: "#7965EF"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M97.8 7.69997C99.8987 7.69997 101.6 5.99865 101.6 3.89996C101.6 1.80128 99.8987 0.0999756 97.8 0.0999756C95.7013 0.0999756 94 1.80128 94 3.89996C94 5.99865 95.7013 7.69997 97.8 7.69997Z",
    fill: "#7965EF"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M82.1 7.69997C84.1987 7.69997 85.9001 5.99865 85.9001 3.89996C85.9001 1.80128 84.1987 0.0999756 82.1 0.0999756C80.0014 0.0999756 78.3 1.80128 78.3 3.89996C78.3 5.99865 80.0014 7.69997 82.1 7.69997Z",
    fill: "#7965EF"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M66.4999 7.69997C68.5986 7.69997 70.2999 5.99865 70.2999 3.89996C70.2999 1.80128 68.5986 0.0999756 66.4999 0.0999756C64.4013 0.0999756 62.7 1.80128 62.7 3.89996C62.7 5.99865 64.4013 7.69997 66.4999 7.69997Z",
    fill: "#7965EF"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M50.8 7.69997C52.8987 7.69997 54.6 5.99865 54.6 3.89996C54.6 1.80128 52.8987 0.0999756 50.8 0.0999756C48.7013 0.0999756 47 1.80128 47 3.89996C47 5.99865 48.7013 7.69997 50.8 7.69997Z",
    fill: "#7965EF"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M35.1 7.69997C37.1987 7.69997 38.9001 5.99865 38.9001 3.89996C38.9001 1.80128 37.1987 0.0999756 35.1 0.0999756C33.0014 0.0999756 31.3 1.80128 31.3 3.89996C31.3 5.99865 33.0014 7.69997 35.1 7.69997Z",
    fill: "#7965EF"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M19.4 7.69997C21.4987 7.69997 23.2 5.99865 23.2 3.89996C23.2 1.80128 21.4987 0.0999756 19.4 0.0999756C17.3013 0.0999756 15.6 1.80128 15.6 3.89996C15.6 5.99865 17.3013 7.69997 19.4 7.69997Z",
    fill: "#7965EF"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M3.79999 7.69997C5.89867 7.69997 7.59998 5.99865 7.59998 3.89996C7.59998 1.80128 5.89867 0.0999756 3.79999 0.0999756C1.70131 0.0999756 0 1.80128 0 3.89996C0 5.99865 1.70131 7.69997 3.79999 7.69997Z",
    fill: "#7965EF"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDots2);
export default __webpack_public_path__ + "static/media/dots_2.99640f88d6ed67deea0af2f0a070d455.svg";
export { ForwardRef as ReactComponent };